import { render, staticRenderFns } from "./AccessorInfo.vue?vue&type=template&id=bb0bda82&scoped=true&"
import script from "./AccessorInfo.vue?vue&type=script&lang=js&"
export * from "./AccessorInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccessorInfo.vue?vue&type=style&index=0&id=bb0bda82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0bda82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
